export default "__VITE_ASSET__D9kvo8pL__"